/* eslint-disable react-hooks/exhaustive-deps */
import { COLORS } from "../../assets/utils/enums/colors";
import { HeadlineTypeEnum } from "../../assets/utils/enums/headline";
import { ThemeTypeEnum } from "../../assets/utils/validation/types";
import { BodyDiv } from "../../components/components-style";
import AppLayout from "../../components/layout/app/layout";
import { Button } from "../../components/ui/button";
import Headline from "../../components/ui/headline";
import folderIcon from "../../assets/images/icons/folder-icon.svg";
import iconStatistic from "../../assets/images/icons/pie-one-icon.svg";
import {
  BoldTextBody,
  LittleHeadline,
  LittleSubHeadline,
  LittleText,
  NotificationText,
  SubTitle,
  TextBody,
} from "../../components/typography";
import styled from "styled-components";
import {
  CommentType,
  prioritiesObj,
  PriorityEnum,
  ProjectMember,
  StageEnum,
  stagesObj,
} from "../../assets/utils/enums/project";
import StatisticBlock, {
  DataStatisticProps,
} from "../../components/ui/statistics-block";
import DataTable from "../../components/ui/table";
import { tableColumnType, TableTypeEnum } from "../../assets/utils/enums/table";
import Input from "../../components/ui/inputs";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CustomToast from "../../components/ui/custom-toast";
import toast from "react-hot-toast";
import { ToastTypeEnum } from "../../assets/utils/enums/toast";
import getData, { FetchError } from "../../api/project-request";
import {
  API_URL_COMMENT,
  API_URL_PROJECT,
  API_URL_SELLING,
  API_URL_TASK,
} from "../../constants";
import { currencies } from "../../assets/utils/data/items";
import { authFetch } from "../../api/authFetch";
import { ModalWindowType } from "../../components/ui/modal-window";
import { ActionsEnum } from "../../assets/utils/enums/settings";
import { useStatisticPeriod } from "../../assets/store/useStatisticPeriod";
import { linkText, LinkText } from "../../components/ui/error-text";
import { FinanceRow, SellingRow, TaskRow } from "../../assets/utils/table-types";
import { formatDate } from "../../assets/utils/date-formatter";
import { FinanceTypeTable } from "../../assets/utils/enums/finance";
import { defaultPermissions, mapPermissions } from "../../assets/utils/hooks/usePermissions";
import CommentListDetails from "../../components/ui/comment/comment-details";
import CommentAdd from "../../components/ui/comment/comment-add";
import { ErrorVariantEnum } from "../../assets/utils/enums/error-page";
import ErrorPage from "../../components/layout/app/error-page";
import handleErrorData from "../../api/error-handler";

export default function DetailsProjectPage() {
  const { id } = useParams<{ id: string }>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const [name, setName] = useState<string>("");
  const [client, setClient] = useState<string>("");
  const [deadline, setDeadline] = useState<string>("");
  const [clientFullName, setClientFullName] = useState<string>("");
  const [responsibleContact, setResponsibleContact] = useState<string>("");
  const [responsibleContactFullName, setResponsibleContactFullName] =
    useState<string>("");
  const [budget, setBudget] = useState<string>("");
  const [company, setCompany] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [priority, setPriority] = useState<string>(PriorityEnum.LOW);
  const [stage, setStage] = useState<string>(StageEnum.IN_WORKS);
  const [currency, setCurrency] = useState<string>(currencies[1].symbol);
  const [members, setMembers] = useState<ProjectMember[]>([]);
  const [tasks, setTasks] = useState<TaskRow[]>([]);
  const [selling, setSelling] = useState<SellingRow[]>([]);
  const [expenses, setExpenses] = useState<FinanceRow[]>([]);
  const [incomes, setIncomes] = useState<FinanceRow[]>([]);
  const [comments, setComments] = useState<CommentType[]>([]);

  const [isChangedComments, setIsChangedComment] = useState<boolean>(false);
  const { period } = useStatisticPeriod();
  const [permissions, setPermissions] = useState(defaultPermissions);
  const [errorStatus, setErrorStatus] = useState<ErrorVariantEnum | null>(null);

  const [modalWindowSettings, setModalWindowSettings] =
    useState<ModalWindowType>({
      isOpen: false,
      onConfirm: () => { },
      onCancel: () => { },
    });

  const [finStatistic, setFinStatistic] = useState<DataStatisticProps[]>([]);

  const getComments = async () => {
    setIsLoading(true);
    try {
      const data = await getData(`${API_URL_COMMENT}/get-comments-by-project?projectId=${id}`);
      if (Array.isArray(data)) {
        setComments(data);
      } else {
        setComments([]);
      }
    } catch (error: any) {
      console.log(error.message);
      setComments([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 100);
    }
  };

  const loadData = async () => {
    try {
      const data = await getData(`${API_URL_PROJECT}/get-details/${id}`);
      if (!data || Object.keys(data).length === 0) {
        setErrorStatus(ErrorVariantEnum.FORBIDDEN);
        return false;
      }

      setName(data.name);
      setClient(data.clientContactEmail || "");
      setClientFullName(data.clientContactFullName || "");
      setCompany(data.companyName || "—");
      setDescription(data.description || "");
      setBudget(data.budget?.toString() || "");
      setDeadline(formatDate(data.deadline) || "");
      setCurrency(data.valutaCode || "UAH");
      setResponsibleContact(data.responsibleUserEmail || "");
      setResponsibleContactFullName(data.responsibleUserFullName || "");
      setPriority(data.priorityName || PriorityEnum.LOW);
      setStage((data.projectStageName as StageEnum) || StageEnum.IN_WORKS);
      setMembers(
        data.users?.map((m: ProjectMember) => ({
          email: m.email || "",
          roleName: m.roleName || "",
          fullName: m.fullName || "",
        })) || []
      );
      setPermissions(mapPermissions({
        edit: data.isEdit,
        delete: data.isDelete
      }));

      return true;
    } catch (e) {
      const error = e as FetchError;

      handleErrorData(error, setErrorStatus);
      return false;
    }
  };

  const getTasks = async () => {
    setIsLoading(true);
    try {
      const data = await getData(
        `${API_URL_TASK}/get-table-tasks-by-project?projectId=${id}`
      );

      if (Array.isArray(data)) {
        setTasks(
          data.map(
            (item): TaskRow => ({
              isChecked: false,
              id: item.id,
              name: item.name || "",
              description: item.description || "",
              deadline: item.deadline || "",
              status: item.status,
              priorityName: item.priorityName || PriorityEnum.LOW,
              createdAt: item.createdAt || Date.now(),
              createdBy: item.responsibleEmail || "",
              usersEmails: item.usersEmails || [""],
              project: item.project || "",
              projectId: item.projectId,
              selling: item.selling || "",
              sellingId: item.sellingId,
            })
          )
        );
      } else {
        setTasks([]);
      }
    } catch (error: any) {
      console.log(error.message);
      setTasks([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 100);
    }
  };

  const getExpenses = async () => {
    setIsLoading(true);
    try {
      const data = await getData(
        `${API_URL_PROJECT}/get-table-expenses-by-project?id=${id}`
      );
      if (Array.isArray(data)) {
        setExpenses(data);
      } else {
        setExpenses([]);
      }
    } catch (error: any) {
      console.log(error.message);
      setExpenses([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 100);
    }
  };

  const getIncomes = async () => {
    setIsLoading(true);
    try {
      const data = await getData(
        `${API_URL_PROJECT}/get-table-incomes-by-project?id=${id}`
      );
      if (Array.isArray(data)) {
        setIncomes(data);
      } else {
        setIncomes([]);
      }
    } catch (error: any) {
      console.log(error.message);
      setIncomes([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 100);
    }
  };

  const getSelling = async () => {
    setIsLoading(true);
    try {
      const data = await getData(
        `${API_URL_SELLING}/get-sellings-by-project?projectId=${id}`
      );
      if (Array.isArray(data)) {
        setSelling(data);
      } else {
        setSelling([]);
      }
    } catch (error: any) {
      console.log(error.message);
      setSelling([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 100);
    }
  };

  useEffect(() => {
    const init = async () => {
      setIsLoading(true);

      const hasAccess = await loadData();

      if (!hasAccess) {
        setIsLoading(false);
        return;
      }

      await Promise.all([
        getTasks(),
        getSelling(),
        getExpenses(),
        getIncomes(),
        getComments(),
      ]);

      setIsLoading(false);
    };

    init();
  }, [id]);


  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      getComments();
      setIsChangedComment(false);
      setIsLoading(false);
    }, 100);
  }, [isChangedComments]);

  useEffect(() => {
    const getStatisticFinance = async () => {
      setIsLoading(true);
      try {
        const data = await getData(
          `${API_URL_PROJECT}/project-finance-summary/${id}?period=${period}&currency=${currencies[1].code}`
        );

        setFinStatistic([
          {
            title: "Надходження",
            value: data.formattedIncomes,
            percent: `${data.incomesChangePercent}`,
          },
          {
            title: "Витрати",
            value: data.formattedExpenses,
            percent: `${data.expensesChangePercent}`,
          },
        ]);
      } catch (error: any) {
        console.log(error.message);
        setFinStatistic([]);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 100);
      }
    };

    if (!errorStatus) return;

    setTimeout(() => {
      getStatisticFinance();
      setIsLoading(false);
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [period]);

  async function deleteFunc() {
    const response = await authFetch(`${API_URL_PROJECT}/archive/${id}`, {
      method: "POST",
      credentials: "include",
    });

    if (response.ok) {
      toast((t) => (
        <CustomToast
          t={t}
          type={ToastTypeEnum.INFO}
          text={"Видалення успішне."}
        />
      ));
    }

    setModalWindowSettings((prev) => ({ ...prev, isOpen: false }));
    navigate("/projects/main");
  }

  if (!isLoading && errorStatus) {
    return (
      <ErrorPage
        variant={errorStatus}
        onAction={() => navigate(-1)}
        additionalBtn="Дo Проєктів"
        onActionAddBtn={() => navigate("/projects/main")}
      />
    );
  }

  return (
    <AppLayout
      className="d-flex flex-column align-items-center gap-2"
      blockType="details-project"
      loaderState={isLoading}
      modalWindow={modalWindowSettings}
    >
      <Headline
        headline={HeadlineTypeEnum.PROJECTS}
        theme={ThemeTypeEnum.LIGHT}
        btn_text="Повернутися до Проєктів"
        btn_link="/projects/main"
        isEdit={false}
      />
      <div className="w-100 d-flex gap-3">
        <BodyDiv
          data-class="detail-main-block"
          className="justify-content-between"
        >
          <span className="d-flex align-items-center gap-3">
            <Button
              bgcolor={COLORS.main2}
              txtcolor={COLORS.white}
              brcolor={"transparent"}
              width="auto"
              className="center-btn"
              brradius="12px"
              type="large"
              onClick={() => { }}
            >
              <img src={folderIcon} alt="folder-icon" />
            </Button>
            <span className="d-flex flex-column ">
              <LittleHeadline>{name}</LittleHeadline>
              <span className="d-flex align-items-center gap-2">
                <NotificationText>Дедлайн:</NotificationText>
                <BoldTextBody>{deadline}</BoldTextBody>
              </span>
              {/* <LittleSubHeadline>{name}</LittleSubHeadline>
              <span className="d-flex align-items-center gap-2">
                <NotificationText>Останні зміни</NotificationText>
                <BoldTextBody>12 Березня 2025</BoldTextBody>
              </span> */}
            </span>
          </span>
          <span className="d-flex justify-content-between gap-4">
            <ItemMainBlock>
              <NotificationText>Компанія</NotificationText>
              <LittleSubHeadline>{company}</LittleSubHeadline>
            </ItemMainBlock>
            <ItemMainBlock>
              <NotificationText>Представник компанії</NotificationText>
              <LinkText mainText={clientFullName} addText={client} />
            </ItemMainBlock>
          </span>
          <ItemMainBlock className="w-100 mw-100">
            <NotificationText>Опис проєкту</NotificationText>
            <LittleSubHeadline>
              {description || "Відсутній опис проєкту"}
            </LittleSubHeadline>
          </ItemMainBlock>

          <ButtonSpan>
            <Button
              bgcolor={COLORS.secondary1}
              txtcolor={COLORS["light-gray"]}
              brcolor={"transparent"}
              width={"50%"}
              className="center-btn"
              brradius="12px"
              type="small"
              noactive={!permissions.edit}
              // disabled={!permissions.edit}
              onClick={() => {
                if (permissions.edit)
                  navigate(`/projects/update/${id}`);
                else
                  toast((t) => (
                    <CustomToast
                      t={t}
                      type={ToastTypeEnum.INFO}
                      text={"У вас немає доступу на редагування."}
                    />
                  ))

              }}
            >
              <LittleText>Редагувати дані</LittleText>
            </Button>
            <Button
              bgcolor={COLORS.warning}
              txtcolor={COLORS["light-gray"]}
              brcolor={"transparent"}
              width="50%"
              className="center-btn"
              brradius="12px"
              noactive={!permissions.delete}
              // disabled={!permissions.delete}
              type="small"
              onClick={() => {
                if (permissions.delete)
                  setModalWindowSettings({
                    isOpen: true,
                    onConfirm: deleteFunc,
                    onCancel: () =>
                      setModalWindowSettings((prev) => ({
                        ...prev,
                        isOpen: false,
                      })),
                    action: ActionsEnum.DELETE,
                  });
                else
                  toast((t) => (
                    <CustomToast
                      t={t}
                      type={ToastTypeEnum.INFO}
                      text={"У вас немає доступу на видалення."}
                    />
                  ))
              }}
            >
              <LittleText>Видалити проєкт</LittleText>
            </Button>
          </ButtonSpan>
        </BodyDiv>
        <div data-class="detail-add-block">
          <BodyDiv className="">
            <span className="d-flex gap-5 w-100">
              <ItemMainBlock className="w-50">
                <NotificationText>Відповідальний контакт</NotificationText>
                <LinkText
                  mainText={responsibleContactFullName}
                  addText={responsibleContact}
                />
              </ItemMainBlock>
              <ItemMainBlock className="w-50">
                <NotificationText>Бюджет</NotificationText>
                <LittleSubHeadline>
                  {currency} {budget}
                </LittleSubHeadline>
              </ItemMainBlock>
            </span>
            <span className="d-flex gap-5">
              <ItemMainBlock className="w-50">
                <NotificationText>Статус</NotificationText>
                <Button
                  bgcolor={stagesObj[stage as StageEnum].bgColor}
                  txtcolor={stagesObj[stage as StageEnum].txColor}
                  brcolor={stagesObj[stage as StageEnum].txColor}
                  width="100%"
                  className="center-btn"
                  brradius="24px"
                  type="large"
                  onClick={() => { }}
                >
                  <LittleText>{stage}</LittleText>
                </Button>
              </ItemMainBlock>
              <ItemMainBlock className="w-50">
                <NotificationText>Пріорітет</NotificationText>
                <Button
                  bgcolor={prioritiesObj[priority as PriorityEnum].bgColor}
                  txtcolor={prioritiesObj[priority as PriorityEnum].txColor}
                  brcolor={prioritiesObj[priority as PriorityEnum].txColor}
                  width="100%"
                  className="center-btn"
                  brradius="24px"
                  type="large"
                  onClick={() => { }}
                >
                  <LittleText>{priority}</LittleText>
                </Button>
              </ItemMainBlock>
            </span>
          </BodyDiv>
          <StatisticBlock
            iconColor={COLORS.blue}
            iconUrl={iconStatistic}
            bgColor={COLORS.white}
            isDropdown={true}
            data={finStatistic}
          />
        </div>
      </div>
      <BodyDiv
        data-class="add-block-members"
        className="d-flex flex-column align-items-start"
      >
        <span className="d-flex flex-column w-100 justify-content-between w-100">
          <SubTitle>Учасники цього проєкту</SubTitle>
          {members.map((item) => (
            <span key={item.email} className="d-flex align-items-center gap-2">
              <Button
                bgcolor={COLORS["light-blue"]}
                txtcolor={COLORS.blue}
                brcolor={COLORS.blue}
                width="auto"
                className="center-btn px-3"
                brradius="24px"
                type="large"
                onClick={() => { }}
              >
                <TextBody>{item.roleName}</TextBody>
              </Button>
              <Button
                bgcolor={"transparent"}
                txtcolor={COLORS.secondary1}
                brcolor={COLORS["bg-text-color"]}
                width="auto"
                className="center-btn px-3"
                brradius="24px"
                type="large"
                onClick={() => { }}
              >
                <TextBody>{item.fullName}</TextBody>
              </Button>
              <Input
                value={item.email}
                setValue={() => { }}
                attribute="role"
                label=""
                errorText=""
                placeholder=""
              />
            </span>
          ))}
        </span>
      </BodyDiv>

      <CommentAdd type="project" objectId={Number.parseInt(id!)} setIsLoading={setIsLoading} setIsChangedComment={setIsChangedComment} />
      <CommentListDetails comments={comments} setIsChangedComment={setIsChangedComment} setModalWindowSettings={setModalWindowSettings} setIsLoading={setIsLoading} />

      <DataTable
        table={tableColumnType[TableTypeEnum.TASKS]}
        data={tasks}
        isPage={TableTypeEnum.PROJECTS}
      />
      <DataTable
        table={tableColumnType[TableTypeEnum.SELLING]}
        data={selling}
        isPage={TableTypeEnum.PROJECTS}
      />
      <DataTable
        table={tableColumnType[TableTypeEnum.FINANCE]}
        data={expenses}
        isPage={TableTypeEnum.PROJECTS}
        isFinanceTitle={FinanceTypeTable.EXPENSE}
      />
      <DataTable
        table={tableColumnType[TableTypeEnum.FINANCE]}
        data={incomes}
        isPage={TableTypeEnum.PROJECTS}
        isFinanceTitle={FinanceTypeTable.INCOME}
      />

    </AppLayout>
  );
}

export const ItemMainBlock = styled.div`
  max-width: 60%;
  min-width: 30%;
  width: fit-content;
  white-space: normal; /* щоб переносило рядки */
  word-break: break-word;
  ${LittleSubHeadline} {
    color: ${COLORS.secondary1} !important;
  }
  ${NotificationText} {
    color: ${COLORS["bg-text-color"]};
  }
  ${NotificationText} {
    padding-bottom: 4px;
  }
  a {
    text-decoration: none;
    ${LittleSubHeadline} {
      width: fit-content;
      ${linkText};
    }
  }
`;

export const ButtonSpan = styled.span`
  width: 100%;
  padding-top: 20px;
  border-top: 2px solid ${COLORS.gray};
  display: flex;
  gap: 16px;
`;
